// DS: CR51
// https://zpl.io/aRzpEyK
import React, { useContext } from 'react';
import classnames from 'classnames';
import DeviationDumbView from '../DeviationViews/Dumbo';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import s from './DeviationsMosaic.scss';
var defaultPadding = parseInt(s['padding']);
var thumbSpacing = parseInt(s['thumb-spacing']);
var mobileThumbSpacing = parseInt(s['mobile-thumb-spacing']);
export var DeviationsMosaic = function (_a) {
    var width = _a.width, height = _a.height, className = _a.className, contentClassName = _a.contentClassName, deviations = _a.deviations, padding = _a.padding, _b = _a.deviationView, DeviationView = _b === void 0 ? DeviationDumbView : _b;
    var isMobile = useContext(MobileContext);
    if (!deviations.length) {
        return React.createElement("div", { style: { width: width, height: height }, className: className });
    }
    if (deviations.length === 1) {
        return (React.createElement(DeviationView, { deviation: deviations[0], width: width, height: height }));
    }
    var effectivePadding = padding !== undefined ? padding : defaultPadding;
    var effectiveThumbSpacing = isMobile ? mobileThumbSpacing : thumbSpacing;
    var fullWidth = width - effectivePadding * 2;
    var fullHeight = height - effectivePadding * 2;
    var halfWidth = Math.floor((fullWidth - effectiveThumbSpacing) / 2);
    var halfHeight = Math.floor((fullHeight - effectiveThumbSpacing) / 2);
    var rightHalf;
    if (deviations.length > 2) {
        rightHalf = (React.createElement("div", { className: s['vertical-tile'] },
            React.createElement("div", { className: s['horizontal-tile'] },
                React.createElement(DeviationView, { deviation: deviations[1], width: halfWidth, height: halfHeight })),
            React.createElement("div", { className: s['horizontal-tile'] },
                React.createElement(DeviationView, { deviation: deviations[2], width: halfWidth, height: halfHeight }))));
    }
    else {
        rightHalf = (React.createElement("div", { className: s['vertical-tile'] },
            React.createElement(DeviationView, { deviation: deviations[1], width: halfWidth, height: fullHeight })));
    }
    return (React.createElement("div", { className: classnames(s['content'], className), style: { width: width, height: height } },
        React.createElement("div", { className: classnames(s['tiles'], contentClassName) },
            React.createElement("div", { className: s['vertical-tile'] },
                React.createElement(DeviationView, { deviation: deviations[0], width: halfWidth, height: fullHeight })),
            rightHalf)));
};
export default DeviationsMosaic;
//# sourceMappingURL=DeviationsMosaic.js.map